import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listPlantMasters,
  listPlantUnits,
  updatePlantMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電所マスタ更新 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useUpdatePlantMaster(): InvalidatingMutationResultFor<
  typeof updatePlantMaster
> {
  return useInvalidatingMutation(updatePlantMaster, [
    createConnectQueryKey({ schema: listPlantMasters, cardinality: 'finite' }),
    // ユニットのエリアは系統コードのエリアから導出するので、エリアを変えたら一覧も取り直す
    createConnectQueryKey({ schema: listPlantUnits, cardinality: 'finite' }),
  ])
}
